import * as React from 'react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';
import { useExperiment } from '@shared-ui/experiment-context';
import { PropertyAboutThisProperty } from '@shared-ui/lodging-property-details';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const AboutThisPropertyWrapper = ({
  inputs,
  columns
}) => {
  var _a, _b;
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  const {
    exposure: topPDPRedesignExposure
  } = useExperiment('Remove_About_the_Property_Web');
  const isTopOfPDPRedesignVariant = topPDPRedesignExposure.bucket === 1;
  const dateRange = (_b = (_a = inputs.searchCriteria) === null || _a === void 0 ? void 0 : _a.primary) === null || _b === void 0 ? void 0 : _b.dateRange;
  const showContent = !isTopOfPDPRedesignVariant || !dateRange;
  const aboutThisProperty = showContent ? React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PropertyAboutThisProperty, {
    inputs: inputs,
    columns: columns,
    skipSsr: cSRPropertyDetailsQuery
  }))) : null;
  return aboutThisProperty;
};
export const SharedUiAboutThisPropertyWrapper = withSharedUiPropertyDetails(AboutThisPropertyWrapper);
SharedUiAboutThisPropertyWrapper.displayName = 'SharedUiAboutThisPropertyWrapper';